import PropTypes from 'prop-types';
import { useTheme, useMediaQuery, IconButton, Tooltip } from '@mui/material';
import { format } from 'date-fns';
import { useTranslate } from 'react-admin';
import ServiceNewIcon from '@/assets/icons/service-new-icon.svg?react';
import { formatIntervalSince } from '@/helpers/date/formatTimeInterval.js';
import parseTimeToSeconds from '@/helpers/date/parseTimeToSeconds';
import ArrowRightSmallIcon from '@/assets/icons/arrow-right-small-icon.svg?react';
import { Palette } from '@/themes/themeOverrides/Palette';

const DeviceServiceStatusField = ({ formatSince, statusText, className, handleClick }) => {
    const theme = useTheme();
    const translate = useTranslate();
    const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.values.lg}px)`);

    const fourHoursInSeconds = 14400;
    const statusTime = formatSince ? formatIntervalSince(formatSince) : translate('resources.device.fields.unknownTime');

    const statusTimeString = typeof statusTime === 'string' ? statusTime : String(statusTime);
    const isLongerThanFourHours = parseTimeToSeconds(statusTimeString) > fourHoursInSeconds;

    return (
        <div className={className}>
            <span style={{ marginRight: '8px', display: 'flex' }}>
                <ServiceNewIcon />
            </span>
            <div style={{ display: 'flex', justifyContent: 'left' }}>
                <span>
                    {statusText}
                    {isMobile ? ' - ' : ''}
                </span>
                <Tooltip title={formatSince ? format(new Date(formatSince), 'dd.MM.yyyy HH:mm') : ''} arrow classes={{ tooltip: 'tooltip-black' }}>
                    <span
                        className='device-status-field-time'
                        style={isLongerThanFourHours ? { color: Palette.red.red900, fontSize: '11px' } : { fontSize: '11px' }}
                    >
                        {statusTime}
                    </span>
                </Tooltip>
            </div>
            {handleClick && (
                <IconButton className='toggle-drawer-button' onClick={handleClick}>
                    <ArrowRightSmallIcon />
                </IconButton>
            )}
        </div>
    );
};

DeviceServiceStatusField.propTypes = {
    formatSince: PropTypes.string,
    statusText: PropTypes.string,
    className: PropTypes.string,
};

export default DeviceServiceStatusField;
